import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/navbar/Navbar';
import Form from '../components/form/Form';
import '../style.css';

const Header = () => {
  const { t } = useTranslation();

  const proofPoints = [
    { icon: 'fa-gift', label: t('header.proof_free') },
    { icon: 'fa-user-group', label: t('header.proof_age') },
    { icon: 'fa-file-pen', label: t('header.proof_essay') },
  ];

  return (
    <header id="header" className="journey-hero">
      <Navbar />
      <div className="container journey-hero__inner">
        <div className="journey-hero__copy">
          <p className="eyebrow">{t('header.eyebrow')}</p>
          <h1>
            {t('header.title_line_one')}
            <span>{t('header.title_line_two')}</span>
          </h1>
          <p className="journey-hero__subtitle">{t('header.subtitle')}</p>

          <div className="journey-hero__proof" aria-label={t('header.proof_label')}>
            {proofPoints.map((item) => (
              <div className="proof-point" key={item.label}>
                <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                <span>{item.label}</span>
              </div>
            ))}
          </div>

          <a className="journey-hero__link" href="#info-beasiswa">
            {t('header.explore')}
            <i className="fa-solid fa-arrow-down" aria-hidden="true" />
          </a>
        </div>

        <div className="journey-hero__form">
          <Form />
        </div>
      </div>
    </header>
  );
};

export default Header;
